import { highlightRanges } from './rankSearch'

interface HighlightedTextProps {
  text: string
  query: string
}

/** Tints only contiguous matches (design 29c), never scattered letters. */
export function HighlightedText({ text, query }: HighlightedTextProps) {
  const ranges = highlightRanges(text, query)
  if (ranges.length === 0) return <span>{text}</span>

  const parts: Array<React.ReactNode> = []
  let last = 0
  for (const [start, end] of ranges) {
    if (last < start) parts.push(text.slice(last, start))
    parts.push(
      <mark
        key={start}
        className="rounded-[3px] bg-brand-tint px-px font-semibold text-foreground"
      >
        {text.slice(start, end)}
      </mark>,
    )
    last = end
  }
  if (last < text.length) parts.push(text.slice(last))
  return <span>{parts}</span>
}
